var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-bot"},[_c('div',{staticClass:"page-width",staticStyle:{"position":"relative"}},[_c('span',[_vm._v("配送千万家商户 成就更好的自己")]),_c('a',{attrs:{"data-toggle":"modal","data-target":"#sj-enlist"},on:{"click":_vm.handleClick}},[_vm._v("我要成为美菜合作司机")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }